import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReleaseModalView from './ReleaseModal.view';

import { getRankedAccountsSliced } from '../../../WorkArea.selectors';

export class ReleaseModalContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { trade, dispatch } = this.props;
    if (trade.type === 'Amazon Gift Card') {
      dispatch({
        $global: true,
        type: 'FETCH_AMAZON_BALANCES',
      });
    }
  }

  render() {
    return (<ReleaseModalView
      {...this.props}
      {...this.state}
    />);
  }

}

function mapStateToProps(state) {
  return {
    rankedAccounts: getRankedAccountsSliced(state),
  };
}

export default connect(mapStateToProps)(ReleaseModalContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/ReleaseModal/ReleaseModal.container.js